"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLUSTER_URLS = exports.Network = void 0;
var Network;
(function (Network) {
    Network["LOCALNET"] = "localnet";
    Network["DEVNET"] = "devnet";
    Network["MAINNET"] = "mainnet";
})(Network = exports.Network || (exports.Network = {}));
exports.CLUSTER_URLS = {
    localnet: "http://127.0.0.1:8899",
    devnet: "https://api.devnet.solana.com",
    mainnet: "https://api.mainnet-beta.solana.com",
};
